import axios from "axios";
import { API_CONFIG, API_URL } from "./apiURL";


let inputData;
export async function getInput(fieldName, diseaseId) {
    // console.log("Inside API call for getCRFInput for field : " + fieldName);

    let url = `${API_URL}getInput/${fieldName}/`;

    if (diseaseId)
        url += diseaseId

    inputData = await axios.get(url, API_CONFIG);
    return inputData.data;
}
